"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _applicant = _interopRequireDefault(require("./applicant"));
var _location = _interopRequireDefault(require("./location"));
var _tag = _interopRequireDefault(require("./tag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  id: _propTypes.default.number,
  title: _propTypes.default.string,
  type: _propTypes.default.string,
  status: _propTypes.default.string,
  statusName: _propTypes.default.string,
  image: _propTypes.default.string,
  applicants: _propTypes.default.arrayOf(_applicant.default),
  tags: _propTypes.default.arrayOf(_tag.default),
  photoUrl: _propTypes.default.string,
  logoUrl: _propTypes.default.string,
  division: _propTypes.default.string,
  qualified: _propTypes.default.bool,
  applied: _propTypes.default.bool,
  opportunityFor: _propTypes.default.number,
  opportunityForName: _propTypes.default.string,
  opportunityForDescription: _propTypes.default.string,
  industries: _propTypes.default.arrayOf(_propTypes.default.shape({
    subIndustryId: _propTypes.default.number,
    industryId: _propTypes.default.number,
    industry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string
    }),
    subIndustry: _propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string
    })
  })),
  duration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  compensation: _propTypes.default.string,
  compensationPeriod: _propTypes.default.number,
  salary: _propTypes.default.string,
  paymentPeriod: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  jobFunctions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),
  summary: _propTypes.default.string,
  locations: _propTypes.default.arrayOf(_location.default),
  compensationType: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  partTimeDuration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  laborActAgreement: _propTypes.default.bool,
  startDay: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  startMonth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  startYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  startHour: _propTypes.default.number,
  anteMeridiem: _propTypes.default.bool,
  reviewApplications: _propTypes.default.bool,
  endDay: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  endMonth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  endYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  endHour: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  endHourAnteMeridiem: _propTypes.default.bool,
  eventDay: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  eventMonth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  eventYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  eventHour: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  eventAnteMeridiem: _propTypes.default.bool,
  expectedDateDay: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  expectedDateMonth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  expectedDateYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  numberOfPotentialHires: _propTypes.default.string,
  expectedDateHire: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  tips: _propTypes.default.string,
  hasExternalApplicationLink: _propTypes.default.bool,
  applicationUrl: _propTypes.default.string,
  applicantsFilter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  atsSystemId: _propTypes.default.number,
  atsSystem: _propTypes.default.string,
  applicationsReceived: _propTypes.default.arrayOf(_propTypes.default.number),
  profilePictures: _propTypes.default.bool,
  diversities: _propTypes.default.bool,
  whyOurCompany: _propTypes.default.bool,
  minGpa: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  majorCategories: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),
  languages: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),
  computer: _propTypes.default.string,
  otherQualifications: _propTypes.default.string,
  requireUsWorkAuthorization: _propTypes.default.bool,
  sponsorWorkVisa: _propTypes.default.bool,
  skipWorkEligibilityQuestions: _propTypes.default.bool,
  hiringTemporarilyAuthorizedCandidates: _propTypes.default.bool,
  teamMediaUrl: _propTypes.default.string,
  teamMediaImageName: _propTypes.default.string,
  teamMediaCaption: _propTypes.default.string,
  teamMediaDescription: _propTypes.default.string,
  teamMediaVideoName: _propTypes.default.string,
  coworkersVideoUrl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  hasTeamMediaVideo: _propTypes.default.bool,
  eventRegistrationUrl: _propTypes.default.string,
  classStanding: _propTypes.default.arrayOf(_propTypes.default.number),
  earlyMonth: _propTypes.default.number,
  earlyYear: _propTypes.default.number,
  lateMonth: _propTypes.default.number,
  lateYear: _propTypes.default.number,
  annualSalaryFrom: _propTypes.default.string,
  annualSalaryTo: _propTypes.default.string,
  visibleForCandidates: _propTypes.default.bool,
  compensationVisibleForStudents: _propTypes.default.bool
});
exports.default = _default;